import { useOktaAuth } from '@okta/okta-react'
import React, {useState, useEffect, useContext, useRef} from 'react';
import { postAllCampaignsAssignments } from '../services/campaign.service';
import { useDispatch, useSelector } from 'react-redux';
import { useUserInfo } from '../providers/userProvider'
import { SCBM_EMPLOYEE_TYPE_ALLOWED } from '../utils/surveyLiterals';
import { MainView } from '../search/MainView';
import { SET_CAMPAIGNS, SET_CAMPAIGNS_ASSIGMENTS } from '../redux/action/types'
import { setStatuses, setCRSSelection, setTitlePage } from '../redux/action/filterAction'
import { getFilterResults } from '../services/search.service'
import { supplierViewFinalSort, orderBy } from '../utils/utils';
import {Context} from "../components/tps/TpsContext";
import { useTranslation } from "react-i18next";




export default function SearchPage() {
    const tpsContext = useContext(Context);
     const {i18n} = useTranslation();
    const { authState } = useOktaAuth();
    const [showModal, setShowModal] = useState(false);
    const userInfo = useUserInfo();
    const dispatch = useDispatch();
    const employeeStatus = useSelector(state => state.filter.statuses)
    const crsSelection = useSelector(state => state.filter.crsSelection)
    const searchTitlePage = useSelector(state => state.filter.searchTitlePage)
    const unitSelection = useSelector(state => state.filter.unitSelection);
    const abortControllerRef = useRef(null);
   
    const changeLanguageToEnglish =() =>{
        i18n.changeLanguage('en');
    }
    useEffect(() => {
        changeLanguageToEnglish();
        const defaultEmployeeSearch = () => {
            dispatch(setCRSSelection(crsSelection))
            dispatch(setStatuses(employeeStatus))
            dispatch(setTitlePage(searchTitlePage))
        }

        async function campaignData() {
            if (userInfo && SCBM_EMPLOYEE_TYPE_ALLOWED.includes(userInfo.userType)) {
                defaultEmployeeSearch()
                // Create new abort controller
                const newAbortController = new AbortController();
                //Store current controller ref
                abortControllerRef.current = newAbortController;
                const filters = JSON.stringify({
                    request: crsSelection.filter(sel => { if (sel.selected) return sel.code }).map((s) => s.code),
                    status: employeeStatus.filter(sel => { if (sel.checked) return sel.label }).map((s) => s.label),
                    unit: unitSelection.filter(sel => { if (sel.checked) return sel.id }).map((s) => s.id)
                })
                return getFilterResults(filters, authState.accessToken.accessToken, true, newAbortController.signal)
                    .then(f => {
                        const finalSort = orderBy(f)
                        dispatch({ type: SET_CAMPAIGNS, payload: finalSort })
                        return f
                    })
                    .catch(e => {
                        dispatch({ type: SET_CAMPAIGNS, payload: [] })
                         
                        return []
                    })
            }

            if (userInfo && !SCBM_EMPLOYEE_TYPE_ALLOWED.includes(userInfo.userType) && userInfo.suppliers.length > 0) {
                return postAllCampaignsAssignments(authState.accessToken.accessToken, userInfo.suppliers)
                    .then((s) => {
                        if (s && s.length > 0) {
                            const finalSort = supplierViewFinalSort(s)
                            dispatch({ type: SET_CAMPAIGNS_ASSIGMENTS, payload: finalSort })
                            return finalSort
                        }
                        else {
                            dispatch({ type: SET_CAMPAIGNS_ASSIGMENTS, payload: [] })
                            return []
                        }

                    })
                    .catch((e) => {
                        dispatch({ type: SET_CAMPAIGNS_ASSIGMENTS, payload: [] })
                        
                        return []
                    })
            }
        }
        campaignData()
    }, [authState.accessToken.accessToken, dispatch, userInfo]);

    function HideModal() {
        setShowModal(false);
    }



    return <MainView userInfo={userInfo} authState={authState} hideModal={HideModal} showModal={showModal} abortControllerRef={abortControllerRef}/>

}